import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth0 } from "../hooks/useAuth0";
import { Box, CircularProgress } from "@mui/material";

// This is the ProtectedRoute actually wired into App.js (a second,
// separate copy lived at components/Auth/ProtectedRoute.jsx — now
// deleted, since it was unused and had this same underlying bug).
//
// requiredRoles was previously accepted as a prop by callers throughout
// App.js but never actually read here — every route wrapped in
// <ProtectedRoute requiredRoles={[...]}> only checked isAuthenticated,
// so any logged-in user of any role could reach any "role-protected"
// route. The backend's own @PreAuthorize checks meant no real data ever
// leaked, but the frontend gave no clean redirect — just a page that
// tried to fetch, got a 403, and showed a generic "failed to load" error.
const ProtectedRoute = ({ children, requiredRoles = [] }) => {
  const { isAuthenticated, isLoading, user } = useAuth0();

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "100vh",
          background: "linear-gradient(135deg, #1A5EA8 0%, #0B2545 100%)",
        }}
      >
        <CircularProgress size={60} sx={{ color: "white" }} />
      </Box>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (requiredRoles.length > 0) {
    const userRoles = user?.roles || [];
    const hasRequiredRole = requiredRoles.some((role) => userRoles.includes(role));
    if (!hasRequiredRole) {
      return <Navigate to="/unauthorized" replace />;
    }
  }

  return children;
};

export default ProtectedRoute;